import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { visitsKeys } from '../../api/query-keys/visits';

import { visitsApi } from '@/features/visits/api/lib/visits';
import { ApiError } from '@/types/interfaces/api-error';

export const useCancelVisit = (onSuccess?: () => void) => {
  const { t } = useTranslation(['visit']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (visitId: number) => visitsApi.cancelVisit(visitId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: visitsKeys.all,
      });
      toast.success(t('visit:status.cancelled'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
